import { type DateRange, getToday, isDateInRange } from "@pentacode/core";
import type { DateString } from "@pentacode/openapi";

/**
 * Manual time and vacation bookings default to the day selected in the list. Without a selection
 * today is the intended date far more often than the start of the displayed range, which only
 * serves as a fallback for ranges that do not contain today.
 */
export function defaultBookingDate(
    activeDate: DateString | null,
    range: DateRange | null,
    today: DateString = getToday()
): DateString {
    return activeDate || (range && !isDateInRange(today, range) ? range.from : today);
}
